import ResourceAndTrainingCard from './component.jsx'
export { iconMap as knownIcons } from './data.js'
export default ResourceAndTrainingCard
